import React from 'react';
import Button from '@/Components/Button';
import Alert from '@/Components/Alert';
import ProgressBar from '@/Components/ProgressBar';
import Billing from './Billing/Billing';
import IconInfo from '@/svgs/info.svg?react';
import { useUiSettings } from '@/Contexts/UiSettingsProvider';
import { Tooltip } from '@/Components/Tooltip';

export default function AlertAccountLimits({
  team,
}: {
  team: App.Data.TeamData;
}) {
  const limit = team.billing.actions_limit;
  const percentage = (team.billing.actions_count / limit) * 100;
  const type = team.billing.plan !== 'free' ? 'pro' : 'free';
  const { settings } = useUiSettings();
  const msg = {
    free: {
      cta: 'View Plans',
      default: 'Upgrade now for more actions, modes, and features.',
      alert: "You're out of actions! Subscribe to pro for 10k per month.",
    },
    pro: {
      cta: 'Upgrade Now',
      default: 'Upgrade now for multiple seats and unlimited actions.',
      alert:
        "You're out of actions! Subscribe to agency for unlimited actions and multiple seats.",
    },
  };

  return !settings.navCollapsed ? (
    <Alert
      className="collapsable relative mx-3 bg-brand-50 p-5 dark:bg-brand-dark-50"
      title={
        <>
          {team.billing.actions_count.toLocaleString()} of{' '}
          {limit.toLocaleString()}
          {type !== 'free' ? '/mo' : ''} Actions Used
        </>
      }
      action={
        <Billing>
          <Button className="w-full justify-center bg-brand-75 text-brand-dark-100 hover:text-brand-dark-100 dark:bg-brand-dark-25 dark:text-white dark:hover:text-brand-dark-100">
            {msg[type].cta}
          </Button>
        </Billing>
      }
    >
      <a
        href="https://intercom.help/wpai/en/articles/8436510-what-are-platform-actions"
        target="_blank"
        className="absolute right-0 top-0 p-2 hover:text-brand dark:hover:text-brand-dark"
      >
        <IconInfo />
      </a>
      <ProgressBar
        status={
          percentage < 70
            ? 'neutral'
            : percentage > 70 && percentage < 90
              ? 'warning'
              : 'alert'
        }
        orientation="horizontal"
        value={percentage}
      />
      <p className="mt-4 text-brand-dark-100/40 dark:text-brand-light-25">
        {percentage >= 100 ? msg[type].alert : msg[type].default}
      </p>
    </Alert>
  ) : (
    <Tooltip
      message={
        <>
          {team.billing.actions_count.toLocaleString()} of{' '}
          {limit.toLocaleString()}
          {type !== 'free' ? '/mo' : ''} Actions Used
        </>
      }
    >
      <div className="h-44 flex justify-center mb-6">
        <ProgressBar
          status={
            percentage < 70
              ? 'neutral'
              : percentage > 70 && percentage < 90
                ? 'warning'
                : 'alert'
          }
          orientation="vertical"
          value={percentage}
        />
      </div>
    </Tooltip>
  );
}
